import jwtDecode from "jwt-decode";
import { AuthContextProps, AuthProvider, useAuth } from "oidc-react";
import React, { useCallback } from "react";
import { auth0Config } from ".";

export const AuthenticationComponentAuth0: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  if (import.meta.env.VITE_DISABLE_AUTH === "true") return <>{children}</>;

  return (
    <AuthProvider {...auth0Config}>
      <AuthWrapper>{children}</AuthWrapper>
    </AuthProvider>
  );
};

const authLogger = (auth: AuthContextProps | null) => {
  if (process.env.NODE_ENV === "development" && auth?.userData?.access_token) {
    const { access_token: accessToken, profile } = auth?.userData;

    let validTill = "";
    try {
      const decoded = new Date(+jwtDecode<{ exp: number }>(accessToken).exp * 1000);
      validTill = new Date(decoded).toISOString();
    } catch (e) {
      console.warn("Could not decode JWT token:", e);
    }
  }
};

const AuthWrapper: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const auth = useAuth();
  const secureChildren = useCallback(() => {
    if (!auth?.userData?.access_token) return null;
    // authLogger(auth);
    return <>{children}</>;
  }, [auth, children]);

  return secureChildren();
};

export default AuthenticationComponentAuth0;
